import MenuPage from "../menu-page/menu-page";
import { useTranslation } from "react-i18next";
import ButtonWithSubtext from "@/components/common/button-with-subtext";

export const SelectGameMode = () => {
  const { t } = useTranslation("create-game");

  return (
    <MenuPage
      subHeaders={[t("subheaders.default")]}
      titles={[t("headers.default")]}
    >
      <div className={"flex flex-1 flex-col items-center justify-center"}>
        <div className={"my-4 flex w-3/4 flex-col space-y-6"}>
          <ButtonWithSubtext
            asLink
            path="/play/create?mode=default"
            // small={true}
            subText={t("body.standardSub")}
          >
            {t("body.standard")}
          </ButtonWithSubtext>

          <ButtonWithSubtext
            asLink
            path="/play/create?mode=otp"
            // small={true}
            subText={t("body.boringSub")}
          >
            {t("body.boring")}
          </ButtonWithSubtext>

          <ButtonWithSubtext
            asLink
            path="/play/create?mode=self-insert"
            // small={true}
            subText={t("body.aboutYouSub")}
          >
            {t("body.aboutYou")}
          </ButtonWithSubtext>

          <ButtonWithSubtext
            asLink
            path="/play/create?mode=missing-history"
            // small={true}
            subText={t("body.brokenTelephoneSub")}
          >
            {t("body.brokenTelephone")}
          </ButtonWithSubtext>

          <ButtonWithSubtext
            asLink
            path="/play/create?mode=solo"
            // small={true}
            subText={t("body.soloModeSub")}
          >
            {t("body.soloMode")}
          </ButtonWithSubtext>
        </div>
      </div>
    </MenuPage>
  );
};
